import StatusProgressBar from "@/components/atom/progress/status/StatusProgressBar";
import { WorkText } from "@/components/atom/text/work/WorkText";
import { WorkTitle } from "@/components/atom/title/work/WorkTitle";
import { QuantityBox } from "@/components/molecule/quantityBox/QuantityBox";
import { COMMON_TEXT } from "@/constants/text";
import { useEquipmentStore } from "@/store/equipment.store";
import { useSocketStore } from "@/store/socket.store";
import { useWorkDataStore } from "@/store/work.store";
import { Flex } from "@mantine/core";

const WorkProgress = Object.assign(
  {},
  {
    Title: WorkTitle,
    Text: WorkText,
    Progress: StatusProgressBar,
  }
);

export const WorkPackingInform = () => {
  const { getData, data } = useSocketStore((state) => ({
    getData: state.getData,
    data: state.data,
  }));

  const { workData } = useWorkDataStore((state) => ({
    workData: state.workData,
  }));
  const { work } = workData;

  const { equipment } = useEquipmentStore((state) => ({
    equipment: state.Equipment,
  }));

  const counterData = getData(equipment?.code as string);

  return (
    <Flex gap={"xs"} direction={"column"}>
      <Flex gap={"xs"} w={"100%"} justify={"space-between"}>
        <>
          {/* 실시간으로 받아오는 데이터 */}
          <QuantityBox
            size="xl"
            color="violet.4"
            value={counterData?.equipmentCounter ?? "0"}
            title={COMMON_TEXT.TITLE.PACKING_COUNT}
          />
          <QuantityBox
            size="xl"
            color="teal.4"
            value={work?.kgPerCount}
            title={COMMON_TEXT.TITLE.KG_PER_COUNT}
          />
          <QuantityBox
            size="xl"
            color="violet.4"
            value={String(
              Number(counterData?.equipmentCounter ?? 0) *
                Number(work?.kgPerCount ?? 0)
            )}
            title={COMMON_TEXT.TITLE.CURRENT_PRODUCT_QUANTITY}
          />
        </>
      </Flex>
    </Flex>
  );
};
